/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_File_Format_LabelInputs */



/**
* | output |
* | --- |
* | "File Format" |
*
* @param {Transcript_Export_File_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_file_format_label = /** @type {((inputs?: Transcript_Export_File_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_File_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format de fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiformat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Формат файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato de archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル形式")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल फ़ारमैट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato do arquivo")
	return /** @type {LocalizedString} */ ("File Format")
});